<div class="cylinder-table-row text">
    <div class="col-no column">
        {{ rowIndex + 1 }}
    </div>
    <div class="col-temp column" data-cy="graphs-exh-gas-cylinder-table-temp-column">
        <ng-container *ngIf="!channel.tempChannel">
            <div
                class="select-button"
                data-cy="graphs-exh-gas-cylinder-table-temp-select-channel-button"
                (click)="openChannelSelector('temp')">
                {{ 'graph.exhaust.table.average.button.select' | translate }}
            </div>
        </ng-container>
        <ng-container
            *ngTemplateOutlet="channelRow; context: { channel: channel.tempChannel, selector: 'temp' }"></ng-container>
    </div>
    <div class="col-deviation column" data-cy="graphs-exh-gas-cylinder-table-dev-column">
        <ng-container *ngIf="!channel.deviationChannel">
            <div
                class="select-button"
                data-cy="graphs-exh-gas-cylinder-table-dev-select-channel-button"
                (click)="openChannelSelector('deviation')">
                {{ 'graph.exhaust.table.average.button.select' | translate }}
            </div>
        </ng-container>
        <ng-container
            *ngTemplateOutlet="
                channelRow;
                context: {
                    channel: channel.deviationChannel,
                    selector: 'deviation',
                }
            "></ng-container>
    </div>
    <div class="col-options column" #iconButton >
        <app-more-options-dropdown
            [isOpen]="optionsVisible"
            (toggle)="openOptions()"
            [options]="moreOptions"
            (optionSelected)="onMoreOptionSelected($event)">
        </app-more-options-dropdown>
    </div>
</div>

<ng-template #channelRow let-channel="channel" let-selector="selector">
    <div class="channel-row" *ngIf="channel">
        <div class="channel-name" data-cy="graphs-exh-gas-cylinder-table-channel-label">
            {{ channel.fcuData.fcuChannelId + ' ' + channel.opsData.name }}
        </div>
        <div class="select-button" (click)="openChannelSelector(selector)">
            {{ 'graph.exhaust.table.channel.button.change' | translate }}
        </div>
    </div>
</ng-template>